import { ColumnDataType } from '@y42/column-type';
import { TransformationStepGitModel, TransformationTypesEnum } from '@y42/json-schema';
import * as uuid from 'uuid';

export enum TransformationStatusEnum {
  ACTIVE = 'active',
  DEPRECATED = 'deprecated',
  BETA = 'beta',
}

export interface TransformationTypeModel {
  id: string;
  order: number;
  title: string;
  logo: string;
  icon: string;
  iconDarkMode: string;
  color: string;
  colorDarkMode: string;
  portColor: string;
  portColorDarkMode: string;
  description: string;
  manipulationType: ManipulationType | null;
  columnType: ColumnDataType | null;
  articleId: string;
  status: TransformationStatusEnum;
  isLowCode: boolean;
}

export interface ManipulationType {
  name: string;
  order: number;
  icon: string;
}

export const createTransformationStepModel = (
  transformationType: TransformationTypesEnum,
  title = '',
): TransformationStepModel => ({
  id: `${uuid.v4()}`,
  title, // dont remove default value.. its important in output component and other that uses this field
  transformationType,
});

export interface TransformationStepModel extends TransformationStepGitModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transformObject?: any;
}
